import { useQuery, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { AppConfiguration, AppConfigurationVersion, VersionChange, VersionChangeDetails } from "@/types/application";

// Coming Soon — no backend API available for configuration versioning yet
export const useConfigurationVersions = (configurationId: string) => {
  const queryClient = useQueryClient();

  const { data: versions, isLoading } = useQuery({
    queryKey: ['config-versions', configurationId],
    queryFn: async (): Promise<AppConfigurationVersion[]> => [],
    enabled: !!configurationId
  });

  const generateChangeDetails = (
    oldConfig: Partial<AppConfiguration>,
    newConfig: Partial<AppConfiguration>
  ): VersionChangeDetails => {
    const changes: VersionChange[] = [];
    if (oldConfig.name !== newConfig.name) changes.push({ field: 'name', oldValue: oldConfig.name, newValue: newConfig.name });
    const summary = changes.length > 0 ? changes.map(c => `Changed ${c.field}`).join(', ') : 'No changes detected';
    return { changes, summary };
  };

  const rollbackToVersion = async (_versionId: string) => {
    toast.info('Version rollback coming soon');
  };

  const labelVersion = async (_versionId: string, _label: string, _isMilestone: boolean = false) => {
    toast.info('Version labeling coming soon');
  };

  const compareVersions = (_versionId1: string, _versionId2: string) => {
    return null;
  };

  return { versions: versions || [], isLoading, rollbackToVersion, labelVersion, compareVersions, generateChangeDetails };
};
